/*
 * Column layout ratios shared by FeatureTableHeader, FeatureTableBody, and the
 * loading skeleton so their columns line up. Keeping them in one place means the
 * skeleton can't silently drift out of alignment with the real table when the
 * ratios are tuned.
 */

/* The header/body switch to the compact ratios once there are more than three
 * tier columns, to keep the extra column from crowding the label. */
export const EXTRA_COLUMNS_THRESHOLD = 3;
export const SEARCH_FLEX_DEFAULT = '1.5';
export const SEARCH_FLEX_COMPACT = '1.2';
export const CTA_WIDTH_DEFAULT = '60%';
export const CTA_WIDTH_WIDE = '80%';
export const LABEL_FLEX_DEFAULT = '1.4';
export const LABEL_FLEX_COMPACT = '1.1';
export function hasExtraColumns(columnCount) {
  return columnCount > EXTRA_COLUMNS_THRESHOLD;
}